export const ZohoFeatures = [
    { name: "Custom Fields", type: "Only in Higher Plans" },
    { name: "Full Call Centre Software", type: "Yes" },
    { name: "Integrated WhatsApp For Business Support (with full Automation like MakeMyTrip)*", type: "3rd Party" },
    { name: "Workflow Management - Automate lead & sales management", type: "Yes" },
    { name: "Booking Form with Support for Agreement + Brokerage Calculations", type: "3rd Party" },
    { name: "Insta Connect - For Instant Auto connected Call back to Customers", type: "No" },
    { name: "Create & Track Price Quotes", type: "Yes" },
    { name: "Schemes & Discounts", type: "3rd Party" },
    { name: "Connected Facebook Adverts Tracking - Auto CPL calculations & Dashboards", type: "3rd Party" },
    { name: "Drip Marketing", type: "Yes" },
    { name: "Inventory management - projects, towers, configurations and units", type: "3rd Party" },
    { name: "Customer Access & Online Interface", type: "No" },
    { name: "Online Bookings, Schemes & Discounts", type: "No" },
    { name: "ISO 27001 Certified Data Security & Compliance", type: "No" }
];
export default ZohoFeatures;
